// extracted by mini-css-extract-plugin
export default {"message":"no-items_message__Qvbjc","tags":"no-items_tags__X5Zo7","button":"no-items_button__VexI1"};